import React from 'react'
import thunder from '../../Images/Vector (7).png';
import userimg from '../../Images/Ellipse 1582.png'
import userimg2 from '../../Images/Ellipse 1582 (1).png'
import userimg3 from '../../Images/Ellipse 1582 (2).png'
import userimg4 from '../../Images/Ellipse 1582 (3).png'
import userimg5 from '../../Images/Ellipse 1582 (4).png'
import star from '../../Images/Group (3).png';
const Suggestions = () => {
  return (
    <>
     <h2 className='search_cities_head' style={{
        paddingTop: '50px',
        paddingBottom:'25px'
     }}>Suggestions For You</h2>
     <div className='suggestions_card_wrapper'>
     {[userimg2, userimg3, userimg4,userimg5,userimg].map((e,i)=>{
        return(
            <>
            <div id={i === 0 && 'active_suggestion'} className='suggestion_card'>
       
       <div className='profile_information_div' style={{
        borderRadius:'15px'
       }}>
       <img style={{
           width:'90px',
           height:'90px',
           borderRadius:'50%'
       }} src={e}/>
           <h2 style={{
            fontSize:'18px',
           marginTop:'10px'
           }}>Swati Srivastava</h2>
           <p>Private Employee</p>
           <div className='rating_reviews_wrapper_div'>
               <p><img src={star}/>4.6</p>
               <h6>97 reviews</h6>
           </div>
           <button className='discover_btn_5' style={{
               display:'flex',
               justifyContent:'flex-start',
               alignItems:'center',
               columnGap:'10px',
               marginTop:'8px'
           }}>
               <img style={{
                   width: '10px',
                  
               }} src={thunder}/>
               Message
           </button>
       </div>
   </div>
            </>
        )
     })}
        
     </div>
    </>
  )
}

export default Suggestions
